// @flow
import React, { type Node } from 'react';

import { buildInfo, buildTitle } from 'app/common/lib/build-info';

import styles from './footer.module.scss';;

/**
 *  Контeйнер для подвала
 */

type Props = {
  children: Node
}

const Footer = ({ children }: Props): Node => {
  return (
    <div className={styles.container} id="footer">
      <hr className={styles.hr} />
      <div className={styles.content}>
        {children}
      </div>
      <div className={styles.ver} title={buildTitle}>{buildInfo}</div>
    </div>
  );
};

export default Footer;
